/**
 * A global namespace for aria-description.
 */
const ariaDescription = "aria-description";
export default ariaDescription;
